<template>
  <Bar
    :chart-options="chartOptions"
    :chart-data="chartData"
    :chart-id="chartId"
    :dataset-id-key="datasetIdKey"
    :plugins="plugins"
    :css-classes="cssClasses"
    :styles="styles"
    :width="width"
    :height="height"
  />
</template>

<script>
import {
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  Title,
  Tooltip
} from "chart.js";
import { Bar } from "vue-chartjs/legacy";

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale
);

export default {
  name: 'OperationTime',
  components: {
    Bar
  },
  props: {
    data: {
      type: Object,
      default: () => null
    },
    chartId: {
      type: String,
      default: "bar-chart"
    },
    datasetIdKey: {
      type: String,
      default: "label"
    },
    width: {
      type: Number,
      default: 400
    },
    height: {
      type: Number,
      default: 200
    },
    cssClasses: {
      default: "",
      type: String
    },
    styles: {
      type: Object,
      default: () => {}
    },
    plugins: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    data: {
      immediate: true,
      handler(val) {
        if (!!val) {
          this.chartData = this.$options.data().chartData
          if (!this.isEmpty(val.operation)){
            this.chartData.datasets[0].data = [val.operation.loading_time]
            this.chartData.datasets[1].data = [val.operation.unloading_time]
            this.chartData.datasets[2].data = [val.operation.fuel_time]
            this.chartData.datasets[3].data = [val.operation.sailing_time]
          }
        }
      }
    }
  },
  data() {
    return {
      chartData: {
        labels: [''],
        datasets: [
          {
            label: 'Loading Time',
            backgroundColor: '#4DA1A9',
            data: [0]
          },
          {
            label: 'Unloading Time',
            backgroundColor: '#004479',
            data: [0]
          },
          {
            label: 'Fuel Time',
            backgroundColor: '#FFAA00',
            data: [0]
          },
          {
            label: 'Sailing Time',
            backgroundColor: '#56B9F2',
            data: [0]
          }
        ]
      },
      chartOptions: {
        indexAxis: 'y', // ⬅️ Make it horizontal
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          x: {
            stacked: true,
            ticks: {
              beginAtZero: true
            }
          },
          y: {
            stacked: true
          }
        },
        plugins: {
          legend: {
            position: 'bottom'
          },
          tooltip: {
            callbacks: {
              label: ctx => `${ctx.raw.toFixed(2)} Day(s)`
            }
          }
        }
      }
    };
  }
};
</script>
